/*
 * Code for this helper was pulled from the sandbox demo for ReactImageCrop
 * https://codesandbox.io/s/react-image-crop-demo-with-react-hooks-y831o
 *
 * The general gist of this method is that it takes the original image and the
 * crop config to create a Canvas that is then converted into a Blob
 * which can then in turn be converted into an image URL, and then finally
 * into an image (not handled here -- this just returns an image URL).
 */
var getCroppedImage = function (sourceImage, cropConfig, width, height, whiteFill) {
    return new Promise(function (resolve, reject) {
        // this is an unfortunate workaround
        if (!sourceImage) {
            reject(new Error("Source image is missing"));
            return;
        }
        // creating the cropped image from the source image
        var canvas = document.createElement("canvas");
        var scaleX = sourceImage.naturalWidth / sourceImage.width;
        var scaleY = sourceImage.naturalHeight / sourceImage.height;
        canvas.width = width;
        canvas.height = height;
        var ctx = canvas.getContext("2d");
        if (!ctx) {
            reject(new Error("Canvas is missing 2D context"));
            return;
        }
        if (whiteFill) {
            ctx.fillStyle = "#fff"; /// set white fill style
            ctx.fillRect(0, 0, canvas.width, canvas.height);
        }
        ctx.drawImage(sourceImage, cropConfig.x * scaleX, cropConfig.y * scaleY, cropConfig.width * scaleX, cropConfig.height * scaleY, 0, 0, width, height);
        canvas.toBlob(function (blob) {
            // returning an error
            if (!blob) {
                reject(new Error("Canvas is empty"));
                return;
            }
            resolve(blob);
        });
    });
};
export default getCroppedImage;
